import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
Vue.use(Vuex);
// Declare empty store first, dynamically register all modules later.
//export default new Vuex.Store<IRootState>({})
const store = new Vuex.Store({ getters });
export default store;
